import type { MenuTypeSlug } from './menuTypes.js';
import type { CourseSlug } from './courses.js';

/**
 * Per-menu course ordering. Course slug → rank; lower prints first.
 * Courses ABSENT from a menu's map are not shown for that menu (strict).
 * Ported verbatim from HOTEL_MENU_COURSE_ORDER in menu-helpers.php.
 */
export const COURSE_ORDER: Record<MenuTypeSlug, Partial<Record<CourseSlug, number>>> = {
  daily: {
    entree: 1,
    'plat-principal': 2,
    dessert: 3,
  },
  formule: {
    entree: 1,
    'plat-principal': 2,
    dessert: 3,
  },
  carte: {
    entree: 1,
    'plat-principal': 2,
    tartiflette: 3,
    pates: 4,
    fromages: 5,
    dessert: 6,
  },
};
